// https://stackoverflow.com/questions/46002113/javascript-reactjs-display-image-with-readablestream-as-source

import React, { useEffect, useState } from 'react';
import { Image } from '@react-pdf/renderer';

import { AxiosError, AxiosResponse } from 'axios';

import formatDataUrlWithUrl from '../_libs/utils/formatDataUrlWithUrl';
import getImageWithUri from '../_libs/utils/getImageWithUri';

import { AzureImageResponseType } from './ImageFromAzureWithOptions';
import { AzureImageWithUriProps } from './ImageFromAzureWithUri';

const PdfImageFromAzureWithUri = ({
  fileUri,
  style = null,
  // No className since react-PDF uses inline-styles instead of CSS classes
  // No alt because react-PDF does not use alt-text for images
}: Omit<AzureImageWithUriProps, 'alt'>): JSX.Element => {
  const [imgSrc, setImgSrc] = useState(null);
  function onError (err: AxiosError) {
    console.error('PdfImageFromAzure: ', err.message);
  }
  function onSuccess (res: AxiosResponse) {
    const data: AzureImageResponseType = res.data;
    if (data.status === 'OK') {
      const dataUrl = formatDataUrlWithUrl(data.dataUrl, data.url);
      setImgSrc(dataUrl);
    } else {
      console.warn('PdfImageFromAzure: ', data.message);
    }
  }
  useEffect(() => {
    if (fileUri) {
      getImageWithUri({
        fileUri,
        opts: {
          onError,
          onSuccess,
        },
      });
    } else {
      // If no fileUri or fileName sent, log error.
      console.error('<PdfImageFromAzure>: Required data is undefined.');
    }
  }, []);
  return (
    imgSrc &&
      <Image src={imgSrc} style={style} />
  );
};

export default PdfImageFromAzureWithUri;
